import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HelpPanelStateService {
  readonly isHelpPanelVisible = signal(false);

  setHelpPanelVisible(visible: boolean): void {
    this.isHelpPanelVisible.set(visible);
  }
}
